import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaSearch } from 'react-icons/fa';
import './FooterPages.css';

const HelpCenter = () => {
    const [searchTerm, setSearchTerm] = useState('');

    const faqs = [
        { q: "How do I register as a Professor of Practice?", a: "To register, click on the 'Get Started' button on the homepage and select 'Professional'. Fill in your details, including your experience and credentials, to submit your profile for verification." },
        { q: "Is there a fee for institutions to join?", a: "Basic registration for institutions is free. However, premium features like advanced matching and unlimited job postings may incur a subscription fee." },
        { q: "How does the vetting process work?", a: "We use a multi-stage vetting process that includes credential verification, employment history checks, and a peer review by our academic panel." },
        { q: "Can students attend sessions for free?", a: "Many sessions are hosted for free by professionals giving back to the community. Some specialized masterclasses may have a fee, which will be clearly indicated." },
        { q: "What if I forget my password?", a: "You can reset your password by clicking on the 'Forgot Password' link on the login page. An email with reset instructions will be sent to your registered address." }
    ];

    const filteredFaqs = faqs.filter(faq =>
        faq.q.toLowerCase().includes(searchTerm.toLowerCase()) ||
        faq.a.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="footer-page-container">
            <div className="footer-page-inner">
                <Link to="/" className="footer-back-btn">
                    <FaArrowLeft /> Back to Home
                </Link>

                <div className="footer-header">
                    <h1 className="footer-title">Help Center</h1>
                    <p className="footer-subtitle">How can we help you today?</p>

                    <div style={{ position: 'relative', maxWidth: '600px', margin: '2rem auto 0' }}>
                        <FaSearch style={{ position: 'absolute', left: '20px', top: '50%', transform: 'translateY(-50%)', color: '#818cf8', fontSize: '1.2rem' }} />
                        <input
                            type="text"
                            placeholder="Search for answers..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '16px 20px 16px 54px',
                                borderRadius: '30px',
                                border: '1px solid rgba(71, 85, 105, 0.4)',
                                background: 'rgba(15, 23, 42, 0.6)',
                                color: '#f8fafc',
                                fontSize: '1.05rem',
                                outline: 'none',
                                backdropFilter: 'blur(12px)',
                                transition: 'all 0.3s ease'
                            }}
                            onFocus={(e) => { e.target.style.borderColor = '#818cf8'; e.target.style.boxShadow = '0 0 0 3px rgba(99, 102, 241, 0.2)'; }}
                            onBlur={(e) => { e.target.style.borderColor = 'rgba(71, 85, 105, 0.4)'; e.target.style.boxShadow = 'none'; }}
                        />
                    </div>
                </div>

                <div style={{ display: 'grid', gap: '1.5rem', maxWidth: '800px', margin: '0 auto' }}>
                    {filteredFaqs.map((faq, index) => (
                        <div key={index} className="footer-glass-card" style={{ padding: '2rem', transform: 'none' }}>
                            <h3 style={{ color: '#f8fafc', marginBottom: '0.75rem', fontSize: '1.2rem', fontWeight: '600' }}>{faq.q}</h3>
                            <p style={{ lineHeight: '1.6', color: 'var(--text-faint)', margin: 0 }}>{faq.a}</p>
                        </div>
                    ))}
                    {filteredFaqs.length === 0 && (
                        <p style={{ textAlign: 'center', fontSize: '1.2rem', color: 'var(--text-faint)', marginTop: '2rem' }}>No results found for "{searchTerm}"</p>
                    )}
                </div>

                <div style={{ marginTop: '5rem', textAlign: 'center' }}>
                    <p style={{ color: 'var(--border)', fontSize: '1.1rem' }}>
                        Still need help? <Link to="/contact" style={{ color: '#818cf8', textDecoration: 'none', fontWeight: 'bold' }}>Contact Support</Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default HelpCenter;


